import { render, staticRenderFns } from "./ViewSalesDeliveryPage.vue?vue&type=template&id=cdc8c9f2"
import script from "./ViewSalesDeliveryPage.vue?vue&type=script&lang=js"
export * from "./ViewSalesDeliveryPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports